import { Switch, withStyles } from "@material-ui/core";
import React from "react";
import Color from "../../styles/Color";

const IOSSwitch = withStyles(theme => ({
    root: {
        width: 60,
        height: 25,
        padding: 0,
        margin: theme.spacing(1),
        marginBottom: 0,
    },
    switchBase: {
        padding: 1,
        "&$checked": {
            transform: "translateX(35.5px)",
            color: theme.palette.common.white,
            "& + $track": {
                backgroundColor: Color.primary,
                opacity: 1,
                border: "none",
                position: "relative",
                "&::before": {
                    content: "'ON'",
                    left: 12,
                    color: "#fff",
                },
            },
        },
        "&$focusVisible $thumb": {
            color: Color.primary,
            border: "6px solid #fff",
        },
    },
    thumb: {
        width: 23,
        height: 23,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
        "&::before": {
            position: "absolute",
            content: "'OFF'",
            top: 5,
            right: 12,
            fontSize: 10,
            fontWeight: 600,
            color: "#555",
        },
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function SwitchIOS({ ...props }) {
    return <IOSSwitch {...props} />;
}
